import { BuildingListing, TourbookSummary } from '@root/types';
import { some } from 'lodash';
import css from './Mobile.module.less';
import AvailableSpaceCard from './Card';

type Props = {
  listings: BuildingListing[];
  buildingSlug: string;
  listingClicked: (listing: BuildingListing, tab: string) => void;
  tourbooks: TourbookSummary[];
  isUserLoggedIn: boolean;
  tabSelectedForAnalytics: string;
};
const AvailableSpacesMobile = ({
  listings,
  buildingSlug,
  listingClicked,
  tourbooks,
  isUserLoggedIn,
  tabSelectedForAnalytics,
}: Props) => {
  const isInTourbook = (listingId: string): boolean =>
    some(tourbooks, tourbook => tourbook.listingIds.includes(listingId));

  return (
    <div className={css.availableSpacesMobile}>
      {listings.map(listing => (
        <AvailableSpaceCard
          listingClicked={() => listingClicked(listing, tabSelectedForAnalytics)}
          listing={listing}
          key={listing.id}
          buildingSlug={buildingSlug}
          isInTourbook={isInTourbook(listing.id)}
          tourbooks={tourbooks}
          isUserLoggedIn={isUserLoggedIn}
        />
      ))}
    </div>
  );
};

export default AvailableSpacesMobile;
